import { CASK_ISSUE_STATUS } from 'common/enum';

export const statusColor: any = {
  [CASK_ISSUE_STATUS.APPROVED]: 'green',
  [CASK_ISSUE_STATUS.REJECTED]: 'red',
  [CASK_ISSUE_STATUS.NEW]: 'blue',
};
